import localizationConstants from 'shared/util/translation/constant';
import { isWhiteLabel } from 'shared/util/utility';
import { IStatus } from '../interface/lobby';

import WebSerieA from 'assets/images/web_serie_a.png';
import MobileSerieA from 'assets/images/mobile_serie_a.png';
import WebBundesliga from 'assets/images/web_bundesliga.png';
import MobileBundesliga from 'assets/images/mobile_bundesliga.png';
import WebLaLiga from 'assets/images/web_la_liga.png';
import MobileLaLiga from 'assets/images/mobile_la_liga.png';
import WebMixed from 'assets/images/web_mixed.png';
import MobileMixed from 'assets/images/mobile_mixed.png';
import WebPremier from 'assets/images/web_premier.png';
import MobilePremier from 'assets/images/mobile_premier.png';
import WebUefaEuropean from 'assets/images/web_uefa_european.png';
import MobileUefaEuropean from 'assets/images/mobile_uefa_european.png';
import EWEBasketLogo from 'assets/images/EWE-baskets-logo.png';
import EWEBanner from 'assets/images/WL-EWE-baskets-logo-banner.png';
import WLNews from 'assets/images/WL-news-banner.png';
import WLNewsMobile from 'assets/images/WL-news-mobile-banner.png';
import WLFanshop from 'assets/images/WL-fanshop-banner.png';
import WLFanshopMobile from 'assets/images//WL-fanshop-moblie-banner.png';
import WLTickets from 'assets/images/WL-tickets-banner.png';
import WLTicketsMobile from 'assets/images/WL-tickets-mobile-banner.png';

const contestStatus = {
	upcoming: 'upcoming',
	live: 'live',
	finished: 'finished',
	joined: 'joined',
	running: 'live'
};

const initDateRange = {
	startDate: new Date(),
	endDate: new Date(),
	key: 'selection'
};

const lobbyFilter: string[] = ['filter', 'Arena', 'Joined', 'Live', 'Finished'];

const lobbyTabLocalization: IStatus = {
	filter: 'filter',
	Arena: localizationConstants.arena,
	Joined: isWhiteLabel ? localizationConstants.tipOff : localizationConstants.joined,
	Live: localizationConstants.live,
	Finished: localizationConstants.finished
};

const lobbyFilterAPI: IStatus = {
	Arena: 'upcoming',
	Joined: 'joined',
	Live: 'live',
	Finished: 'history'
};

const contestCurrentStatus = {
	Arena: 'Arena',
	Joined: 'Joined',
	Live: 'Live',
	Finished: 'Finished'
};

const contestStatusLocalization: IStatus = {
	upcoming: localizationConstants.upcoming,
	Joined: localizationConstants.joinedStatusTag,
	live: localizationConstants.live,
	finished: localizationConstants.finished,
	abort: localizationConstants.cancelled,
	'Cancl.': localizationConstants.cancelled,
	'Postp.': localizationConstants.cancelled
};

const lobbyFilterTags: IStatus = {
	Arena: 'Upcoming',
	Joined: 'Joined',
	Live: 'Live',
	Finished: 'Finished'
};

const modeName: IStatus = {
	'8f41c6a7-365c-4779-b0a0-fa9aa888054e': 'Beginner',
	'702f8707-66ff-4e67-8fc6-bb871443b55d': 'Tournament',
	'4a24f4e1-6536-4ed2-8e8f-4b999cfd50c1': 'Head to Head',
	'95a3d705-4f6a-4b24-911d-e1ed3c04577b': 'Multipliers',
	'68b64060-b431-41b8-9a97-846f1e8db797': '50/50s'
};

const mode = {
	private: 'private',
	public: 'public'
};
/*---------For Lottery Version---------- */
/* const lobbyBannerList = [
	{
		banner: Contest5,
		message: localizationConstants.contest1,
		writer: localizationConstants.contest1_writer,
		m1: localizationConstants.contest1_1,
		m2: localizationConstants.contest1_2,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest6,
		message: localizationConstants.contest2,
		writer: localizationConstants.contest2_writer,
		m1: localizationConstants.contest2_1,
		m2: localizationConstants.contest2_2,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest7,
		message: localizationConstants.contest3,
		writer: localizationConstants.contest3_writer,
		m1: localizationConstants.contest3_1,
		m2: localizationConstants.contest3_2,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest8,
		message: localizationConstants.contest4,
		writer: localizationConstants.contest4_writer,
		m1: localizationConstants.contest4_1,
		m2: localizationConstants.contest4_2,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest4,
		message: localizationConstants.contest5,
		writer: localizationConstants.contest5_writer,
		m1: localizationConstants.contest5_1,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest1,
		message: '',
		writer: '',
		isPrizePool: true,
		isWriter: true,
		m1: localizationConstants.contest6_1,
		m2: localizationConstants.contest6_2,
		m3: localizationConstants.contest6_3,
		m4: localizationConstants.contest6_4
	},
	{
		banner: Contest2,
		message: '',
		writer: '',
		isPrizePool: true,
		isWriter: true,
		m1: localizationConstants.contest7_1,
		m2: localizationConstants.contest7_2,
		m3: localizationConstants.contest7_3,
		m4: localizationConstants.contest7_4
	},
	{
		banner: Contest3,
		message: localizationConstants.contest8,
		writer: '',
		m1: localizationConstants.contest8_1,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest9,
		message: localizationConstants.contest9,
		writer: '',
		m1: localizationConstants.contest9_1,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest10,
		message: localizationConstants.contest10,
		writer: '',
		m1: localizationConstants.contest10_1,
		isPrizePool: false,
		isWriter: false
	},
	{ banner: Contest11, message: localizationConstants.contest11, writer: '', isPrizePool: false, isWriter: true },
	{
		banner: Contest12,
		message: localizationConstants.contest12,
		writer: '',
		m1: localizationConstants.contest12_1,
		isPrizePool: false,
		isWriter: false
	},
	{
		banner: Contest13,
		message: localizationConstants.contest13,
		writer: '',
		m1: localizationConstants.contest13_1,
		m2: localizationConstants.contest13_2,
		isPrizePool: false,
		isWriter: false
	}
]; */

const lobbyBannerList = [
	{
		webBanner: WebUefaEuropean,
		mobileBanner: MobileUefaEuropean,
		titles: [localizationConstants.uefaEuropeanTitle_1, localizationConstants.uefaEuropeanTitle_2],
		titleColor: '',
		subTitleColor: '',
		subTitles: [localizationConstants.uefaEuropeanSubTitle_1, localizationConstants.uefaEuropeanSubTitle_2]
	},
	{
		webBanner: WebBundesliga,
		mobileBanner: MobileBundesliga,
		titles: [
			localizationConstants.bundesLigaTitle_1,
			localizationConstants.bundesLigaTitle_2,
			localizationConstants.bundesLigaTitle_3
		],
		titleColor: '',
		subTitleColor: 'contest-sub-title--black',
		subTitles: [localizationConstants.bundesLigaSubTitle_1, localizationConstants.bundesLigaSubTitle_2]
	},
	{
		webBanner: WebPremier,
		mobileBanner: MobilePremier,
		titles: [
			localizationConstants.premierTitle_1,
			localizationConstants.premierTitle_2,
			localizationConstants.premierTitle_3
		],
		titleColor: '',
		subTitleColor: '',
		subTitles: [localizationConstants.premierSubTitle_1, localizationConstants.premierSubTitle_2]
	},
	{
		webBanner: WebLaLiga,
		mobileBanner: MobileLaLiga,
		titles: [
			localizationConstants.laLigaTitle_1,
			localizationConstants.laLigaTitle_2,
			localizationConstants.laLigaTitle_3
		],
		titleColor: '',
		subTitleColor: '',
		subTitles: [localizationConstants.laLigaSubTitle_1, localizationConstants.laLigaSubTitle_2]
	},
	{
		webBanner: WebSerieA,
		mobileBanner: MobileSerieA,
		titles: [
			localizationConstants.seireATitle_1,
			localizationConstants.seireATitle_2,
			localizationConstants.seireATitle_3
		],
		titleColor: 'contest-title--black',
		subTitleColor: 'contest-sub-title--gray',
		subTitles: [localizationConstants.serieASubTitle_1, localizationConstants.serieASubTitle_2]
	},
	{
		webBanner: WebMixed,
		mobileBanner: MobileMixed,
		titles: [
			localizationConstants.mixedTitle_1,
			localizationConstants.mixedTitle_2,
			localizationConstants.mixedTitle_3
		],
		titleColor: '',
		subTitleColor: '',
		subTitles: [localizationConstants.mixedSubTitle_1, localizationConstants.mixedSubTitle_2]
	}
];

const WLLobbyBannerList = [
	{
		webBanner: EWEBanner,
		mobileBanner: EWEBanner,
		logoImage: EWEBasketLogo,
		title: '',
		redirectLink: 'https://ewe-baskets.de/'
	},
	{
		webBanner: WLNews,
		mobileBanner: WLNewsMobile,
		title: localizationConstants.news,
		redirectLink: 'https://ewe-baskets.de/news/index.html'
	},
	{
		webBanner: WLFanshop,
		mobileBanner: WLFanshopMobile,
		title: localizationConstants.fanshop,
		redirectLink: 'https://shop.ewe-baskets.de/'
	},
	{
		webBanner: WLTickets,
		mobileBanner: WLTicketsMobile,
		title: localizationConstants.tickets,
		redirectLink: 'https://ewe-baskets.de/tickets/index.html'
	}
];

export {
	contestStatus,
	lobbyFilter,
	initDateRange,
	lobbyFilterAPI,
	contestCurrentStatus,
	lobbyFilterTags,
	modeName,
	contestStatusLocalization,
	lobbyTabLocalization,
	mode,
	lobbyBannerList,
	WLLobbyBannerList
};
